// extracted by mini-css-extract-plugin
module.exports = {"link":"BlogSample_link__1CMzR","sample":"BlogSample_sample__2lgns"};